var _ = require('underscore');
module.exports = function(options){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
__p+='';

  let {
    school,
    tracking
  } = options;

__p+='\n\n<tr>\n    <td class="text-align-center">\n        ';

            var hasRatingsNode = typeof school.ratings !== 'undefined' && school.ratings.length !== 0;
            var score =
                    (hasRatingsNode && typeof school.ratings.great_schools !== 'undefined')? school.ratings.great_schools : 'NR';
        
__p+='\n        <span class="school-rating">'+
((__t=( score ))==null?'':__t)+
'</span>\n    </td>\n    <td><a data-omtag=\'local:schools:'+
((__t=(tracking))==null?'':__t)+
'\' href="'+
((__t=( school.slug ))==null?'':__t)+
'">'+
((__t=( school.name ))==null?'':__t)+
'</a></td>\n    <td class="text-align-center hidden-xxs hidden-xs">\n        ';

            var hasGrades = typeof school.grades !== 'undefined' && school.grades !== null && school.grades.length !== 0;
            var grades =
                (hasGrades)? school.grades[0] + '&ndash;' + school.grades[school.grades.length -1] : '&ndash;';
        
__p+='\n        '+
((__t=( grades ))==null?'':__t)+
'\n    </td>\n    <td class="text-align-center hidden-xxs hidden-xs">\n        <div class="star-rating">\n            ';

                var parentRating = '';
                var stars =
                        ( hasRatingsNode && typeof school.ratings.parent_rating !== 'undefined')?school.ratings.parent_rating: -1;
                if (stars === -1){
                    parentRating = 'N/A';
                }
                else{
                    for (var i=1; i <= stars; i++){
                        parentRating += '<i class="ra ra-star"></i>';
                    }
                    for (i = stars+1; i <= 5; i++){
                        parentRating += '<i class="ra ra-star rating-dim"></i>';
                    }
                }
            
__p+='\n            '+
((__t=( parentRating))==null?'':__t)+
'\n        </div>\n    </td>\n    <td class="text-align-center hidden-xxs hidden-xs">\n        <a data-omtag="local:schools:'+
((__t=(tracking))==null?'':__t)+
':schoolsrp" href="'+
((__t=( school.url_srp))==null?'':__t)+
'">View nearby homes</a>    \n    </td>\n</tr>\n';
return __p;
};



// WEBPACK FOOTER //
// ./templates/local_school_table_row.jst.ejs